import React from 'react';
import { Alert, Toast } from 'react-bootstrap';
import PropTypes from 'prop-types';
const NotificationAlert = ({
  message,
  showNotification,
  setShowNotification,
  isError = true
}) => {
  return (
    <>
      <div className="position-fixed bottom-0 end-0 z-3">
        <Toast
          onClose={() => {
            setShowNotification(false);
          }}
          show={showNotification}
          delay={3000}
          autohide
        >
          <Toast.Header>
            <strong className="me-auto">Aviso</strong>
          </Toast.Header>
          <Toast.Body className="bg-100">
            <Alert key="warning" variant={isError ? 'danger' : 'success'}>
              {message}
            </Alert>
          </Toast.Body>
        </Toast>
      </div>
    </>
  );
};
NotificationAlert.propTypes = {
  message: PropTypes.string.isRequired,
  showNotification: PropTypes.bool,
  setShowNotification: PropTypes.func,
  isError: PropTypes.bool
};
export default NotificationAlert;
